import request from './request'

export function listDivision(data) {
  return request.post('/mes/divisions/list', data)
}
export function selectDivision() {
  return request.get('/mes/divisions/select')
}
export function getDivision(id) {
  return request.get('/mes/divisions/' + id)
}
export function saveDivision(data) {
  return request.post('/mes/divisions', data)
}
export function updateDivision(data) {
  return request.post('/mes/divisions/update', data)
}
export function deleteDivision(ids) {
  return request.post('/mes/divisions/delete', ids)
}
